module.exports = __webpack_public_path__ + "img/蒙版组 187.82adb1a7.svg";